export enum OtaThemes {
  SEJUREXOTIC = 'sejurexotic',
  SEJUREUROPA = 'sejureuropa',
}

export enum B2bThemes {
  DEFAULT = 'default',
  TEST = 'test',
}

export enum ChatbotThemes {
  ETURIA = 'eturia',
  DEFAULT = 'default'
}
